import { ActionIcon, Anchor, Group } from "@mantine/core";
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandPinterest,
  IconBrandTwitter,
  IconCode,
} from "@tabler/icons-react";
import { useSessionStore } from "stores/userSessionStore";

const FooterSocialIcons = () => {
  const { isGlobalAdmin } = useSessionStore();
  return (
    <Group gap="xs">
      {isGlobalAdmin && (
        <>
          <Anchor href="https://facebook.com" target="_blank">
            <ActionIcon variant="light" size="lg" color="blue">
              <IconBrandFacebook size={20} />
            </ActionIcon>
          </Anchor>
          <Anchor href="https://twitter.com" target="_blank">
            <ActionIcon variant="light" size="lg" color="blue">
              <IconBrandTwitter size={20} />
            </ActionIcon>
          </Anchor>
          <Anchor href="https://pinterest.com" target="_blank">
            <ActionIcon variant="light" size="lg" color="red">
              <IconBrandPinterest size={20} />
            </ActionIcon>
          </Anchor>
          <Anchor href="https://instagram.com" target="_blank">
            <ActionIcon variant="light" size="lg" color="grape">
              <IconBrandInstagram size={20} />
            </ActionIcon>
          </Anchor>
        </>
      )}
      <Anchor href="https://dashcode.co.nz" target="_blank">
        <ActionIcon variant="light" size="lg" color="indigo">
          <IconCode size={20} />
        </ActionIcon>
      </Anchor>
    </Group>
  );
};

export default FooterSocialIcons;
